import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import Home from '@/pages/Home';
import { RootState } from '@/utils/store';

const IndexRoute: FC = () => {
  const isAuthenticated = useSelector((state: RootState) => !!state.auth.user);

  return <>{isAuthenticated ? <Navigate to="/general" replace /> : <Home />}</>;
};

export default IndexRoute;
